module.exports = __webpack_public_path__ + "media/static/icons/icon-beach--green-2a3d54318e9488e32b9269dcb2148581.svg";